import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { buscarProdutosMercadinho, buscarProdutosEstabelecimento, cadastrarProdutosEstabelecimento } from '../../services/api';
// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./ProdutosPage.css";
import '../../styles/global.css';
import Carregando from '../../components/Carregando/Carregando';

const ProdutosPage = () => {

    const navigate = useNavigate();
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const BASE_URL = JSON.parse(sessionStorage.getItem('BASE_URL'));
    const [produtos, setProdutos] = useState([]);

    const [carregando, setCarregando] = useState(false);    

    const [produtosSelecionados, setProdutosSelecionados] = useState(
        produtos.length > 0 ? produtos.reduce((acc, produto) => ({ ...acc, [produto.id]: false }), {}) : {}
    );

    // controlar visibilidade das categorias de produtos
    const [categoriasVisiveis, setCategoriasVisiveis] = useState({});
    const toggleCategoria = (categoria) => {
        setCategoriasVisiveis((prev) => ({
            ...prev,
            [categoria]: !prev[categoria],
        }));
    };
  
    const [produtosEstabelecimento, setProdutosEstabelecimento] = useState({});

    // método que busca os produtos - está sendo chamado em useEffect
    const fetchDadosProdutos = async () => {
        // buscar todos os produtos do mercadinho
        await fetchProdutosMercadinho();
        // buscar todos os produtos do estabelecimento
        await fetchProdutosEstabelecimento();
    };


    useEffect(() => {
        console.log('--- ENTROU EM PRODUTOS PAGE ----');
        setCarregando(true);
        if (userData) {
            try {
                if (userData.statusUsuario === 'logado') {

                    const idEstabelecimento = userData.dadosEstabelecimento.id;

                    // buscar todos os produtos, tanto do mercadinho, quanto do estabelecimento
                    fetchDadosProdutos();

                    setCarregando(false);

                } else {
                    console.log('Usuário não está logado, mantendo na área restrita.');
                }
            } catch (error) {
                console.error('Erro ao parsear os dados de usuário:', error);
            }
        } else {
            console.log('Usuário NÃO está logado!');
        }

    }, []);


    // vamos verificar os produtosEstabelecimento que estão nos produtos (todos produtos do mercadinho)
    useEffect(() => {
        console.log('Entrou no useEffect 2');
        console.log('produtosEstabelecimento:', produtosEstabelecimento[0]);
        setCarregando(true);
        if (produtos.length > 0 && produtosEstabelecimento.length > 0) {
            const produtosSelecionadosAtualizados = { ...produtosSelecionados };
            produtos.forEach((produto) => {
                produtosSelecionadosAtualizados[produto.id] = produtosEstabelecimento.some((produtoEstabelecimento) => produtoEstabelecimento.produto_id === produto.id);
            });
            console.log('produtosSelecionadosAtualizados:', produtosSelecionadosAtualizados);
            setProdutosSelecionados(produtosSelecionadosAtualizados);
        }
        setCarregando(false);
    }, [produtos, produtosEstabelecimento]);

    const handleCheckboxChange = useCallback((produtoId) => {
        
        console.log('--- clicou ---');
        console.log('id do produto: ');
        console.log(produtoId);

        setProdutosSelecionados((prevProdutosSelecionados) => {
            const novoEstado = { ...prevProdutosSelecionados };
            novoEstado[produtoId] = !novoEstado[produtoId];
            return novoEstado;
        });

    }, [setProdutosSelecionados]);

    // buscar todos os produtos do mercadinho, para seleção
    const fetchProdutosMercadinho = async () => {
        setCarregando(true);
        console.log('Entrou em fetchProdutosMercadinho em ProdutosPage');
        try {
            const dados = await buscarProdutosMercadinho(userData);

            console.log('*** produtos do mercadinho: ***', dados.produtosMercadinho);

            if (dados?.produtosMercadinho) {
                // vamos setar em produtos, os produtos que vieram em produtosMercadinho
                setProdutos(dados.produtosMercadinho);
            }
            setCarregando(false);
        } catch (error) {
            setCarregando(false);
            console.error('Erro ao buscar produtos:', error);
        }
    };

    // buscar todos os produtos do estabelecimento, para checkar os que já tem
    const fetchProdutosEstabelecimento = async () => {
        console.log('Entrou em fetchProdutosEstabelecimento em ProdutosPage');
        setCarregando(true);
        try {
            const dados = await buscarProdutosEstabelecimento(userData);

            console.log('*** produtos estab ***', dados.produtosEstabelecimento);

            if (dados?.produtosEstabelecimento) {
                // vamos setar os produtos do estabelecimento
                setProdutosEstabelecimento(dados.produtosEstabelecimento);
            }
            setCarregando(false);

        } catch (error) {
            setCarregando(false);
            console.error('Erro ao buscar produtos:', error);
        }
    };

    // Função para redirecionar para MeusProdutosPage
    const handleGoToMeusProdutos = async (e) => {
        e.preventDefault();
        navigate('/meus-produtos');
    };

    // Função para redirecionar para CadastrarOutrosProdutosPage
    const handleGoToCadastrarOutrosProdutos = async (e) => {
        e.preventDefault();
        navigate('/form-cadastrar-outros-produtos');
    };

    const handleSubmit = async (e) => {

        setCarregando(true);

        e.preventDefault();
        const selecionados = Object.keys(produtosSelecionados).filter((id) => produtosSelecionados[id]);

        // vamos gerar os dados para enviar para a api
        const dados = {
            idEstabelecimento: userData.dadosEstabelecimento.id,
            produtosSelecionados: selecionados,
        };
          
        try {
            const response = await cadastrarProdutosEstabelecimento(dados);
            alert('Produtos atualizados com sucesso!');
            setCarregando(false);
            navigate('/meus-produtos');
        } catch (error) {
            console.error('Erro ao cadastrar produtos:', error);
            const errorMessage = error.response?.data?.message || 'Erro ao cadastrar os produtos. Tente novamente.';
            alert(errorMessage);
            setCarregando(false);
        }
      };

  // Agrupar produtos por categoria
  const produtosPorCategoria = produtos.reduce((acc, produto) => {
    const nomeCategoria = produto.nome_categoria_produto;
    if (!acc[nomeCategoria]) {
      acc[nomeCategoria] = [];
    }
    acc[nomeCategoria].push(produto);
    return acc;
  }, {});

  if (carregando) {
    return <Carregando />;
  }

    return (
        <div className="form-cadastrar-container">
            <TituloComponent />

            <form onSubmit={handleSubmit}>
                <h2 className="form-title">Cadastro de Produtos</h2>

                <div className="box-dados">
                    {/* Exibe o nome do perfil do usuário */}
                    <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome }!</p>
                    {/* Botão Meus Produtos */}
                    <button className="welcome-btn" onClick={handleGoToMeusProdutos}>Produtos já cadastrados</button>
                    {/* Botão Outros Produtos */}
                    <button className="welcome-btn" onClick={handleGoToCadastrarOutrosProdutos}>Cadastrar outros Produtos</button>
                </div>

                <h2 className="form-title">Importar produtos para o Estabelecimento</h2>

                {produtos.length > 0 ? (
                    <div>
                        {Object.entries(produtosPorCategoria).map(([nomeCategoria, produtos]) => (
                            <div key={nomeCategoria} >

                                <div 
                                    className="box-categoria"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => toggleCategoria(nomeCategoria)}
                                >
                                    <h1 className="sub-titulo" >
                                    {nomeCategoria}
                                    </h1>
                                </div>

                                {categoriasVisiveis[nomeCategoria] && (
                                <div >
                                    {produtos.map((produto, index) => (
                                    <div
                                        key={index}
                                        className="produto-item"
                                        style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        padding: '10px 0',
                                        borderBottom: '1px solid #ccc',
                                        }}
                                    >
                                        <div>
                                            <input
                                                type="checkbox"
                                                checked={
                                                produtosSelecionados[produto.id] !== undefined
                                                    ? produtosSelecionados[produto.id]
                                                    : false
                                                }
                                                onChange={() => handleCheckboxChange(produto.id)}
                                            />
                                        </div>
                                        <div>
                                            {produto?.caminhoImagemProduto ? (
                                                <img
                                                src={BASE_URL + produto.caminhoImagemProduto}
                                                alt={produto.nome}
                                                width="60px"
                                                />
                                            ) : (
                                                <span>Imagem não disponível</span>
                                            )}
                                        </div>
                                        <div>{produto?.nome || 'Não informado'}</div>
                                    </div>
                                    ))}
                                </div>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <label htmlFor="numeroMesa">Nenhum produto cadastrado.</label>
                )}

                {/* Box com botão */}
                <div className="box-dados">
                    {/* Exibe o nome do perfil do usuário */}
                    <p className="texto-welcome">Apenas os produtos marcados farão parte da sua lista de produtos.</p>
                    <button type="submit" className="welcome-btn">
                        Atualizar meus produtos
                    </button>
                </div>

            </form>

            {/* Espaço entre o botão e a tabela */}
            <div className="mt-4"></div>

        </div>
    );
};

export default ProdutosPage;
